<template>
  <div class="board-column">
    <div class="d-flex align-center px-2 py-1" style="gap: 6px">
      <span class="font-weight-medium">{{ title }}</span>
      <v-spacer />
      <!-- FT-091: массовая архивация «Отъездила» одной кнопкой (роль-гейт снаружи) -->
      <v-btn
        v-if="bulkArchive && total > 0"
        icon
        x-small
        :loading="bulkArchiving"
        :title="$t('board.archive_all_rided')"
        @click="$emit('bulk-archive')"
      >
        <v-icon small>mdi-archive-arrow-down-outline</v-icon>
      </v-btn>
      <v-chip v-if="!initialLoading" x-small>{{ bookings.length }} / {{ total }}</v-chip>
      <v-skeleton-loader v-else type="chip" />
    </div>
    <div ref="scroll" class="board-column__scroll pa-1">
      <!-- FT-082: first-load placeholders so the board isn't blank on entry -->
      <template v-if="initialLoading">
        <v-skeleton-loader
          v-for="n in 5"
          :key="'sk-' + n"
          type="list-item-three-line"
          class="board-column__skeleton mb-2"
        />
      </template>
      <template v-else>
        <booking-board-card
          v-for="b in bookings"
          :key="b.id"
          :booking="b"
          :states="states"
          @changed="$emit('changed')"
          @archived="$emit('archived', $event)"
          @send-template="$emit('send-template', $event)"
          @open-tasks="$emit('open-tasks', $event)"
        />
        <div
          v-if="bookings.length < total"
          ref="sentinel"
          class="board-column__sentinel"
        >
          <v-progress-circular
            v-if="loading"
            indeterminate
            size="20"
            width="2"
            color="primary"
          />
          <v-btn v-else block small text @click="$emit('load-more')">
            {{ $t("custom.show_more") }}
          </v-btn>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BookingBoardCard from "@/components/dashboard/bookings/board/BookingBoardCard.vue";

export default {
  name: "BookingBoardColumn",
  components: { BookingBoardCard },
  props: {
    title: { type: String, required: true },
    bookings: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    initialLoading: { type: Boolean, default: false },
    states: { type: Array, default: () => [] },
    bulkArchive: { type: Boolean, default: false },
    bulkArchiving: { type: Boolean, default: false },
  },
  mounted() {
    // Lazy-load: auto-fetch the next page when the sentinel scrolls into view.
    if (typeof IntersectionObserver === "undefined") return;
    this.observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          !this.loading &&
          this.bookings.length < this.total
        ) {
          this.$emit("load-more");
        }
      },
      { root: this.$refs.scroll, rootMargin: "200px" }
    );
    this.observeSentinel();
  },
  updated() {
    // The sentinel is re-created / moved as cards append or the column resets;
    // re-attach the observer to the current element each render.
    this.observeSentinel();
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    observeSentinel() {
      if (!this.observer) return;
      this.observer.disconnect();
      if (this.$refs.sentinel) this.observer.observe(this.$refs.sentinel);
    },
  },
};
</script>

<style scoped>
.board-column {
  min-width: 280px;
  max-width: 320px;
  flex: 1 1 0;
  background: rgba(127, 127, 127, 0.08);
  border-radius: 6px;
}
.board-column__scroll {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
.board-column__sentinel {
  display: flex;
  justify-content: center;
  padding: 8px 0;
}
/* skeleton cards mimic the real board cards' surface + rounding */
.board-column__skeleton {
  border-radius: 6px;
  overflow: hidden;
}
</style>
